<template>
    <form-field v-bind="{ ...fieldProps, label: undefined }">
        <switch-input v-bind="inputProps" @change="change($event)" @emitEvent="emitEvent($event, ['change'])">
            <template #label>
                <slot name="label"></slot>
            </template>
        </switch-input>

        <template #hint>
            <slot name="hint"></slot>
        </template>

        <template #right>
            <slot name="right"></slot>
        </template>

        <template #error="{ error }">
            <slot name="error" :error="error"></slot>
        </template>
    </form-field>
</template>

<script>
    import FormFieldMixin from 'mixins/FormFieldMixin'

    export default {
        mixins: [FormFieldMixin],

        props: {
            isLabelOnLeft: { type: Boolean, default: false },
        },
    }
</script>
